export default __webpack_public_path__ + "tiktok.cf12e5af.png";